<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Serviço de Remoção</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Tipos de Ambulâncias',
          options: listaTiposRemocao,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile">
      <single-select
        @input="atualizarAbrangencias"
        :propsSingleSelect="{
          placeholder: 'Abrangência',
          options: listaAbrangencias,
          'track-by': 'id',
          label: 'tipoServicoAbrangencia'
        }"
        :value="payload.tipoServicoAbrangencia"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile">
      <single-select
        @input="atualizarServicoPublico"
        :propsSingleSelect="{
          placeholder: 'Público',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        :value="payload.tipoServicoPublico"
        v-show="clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    Multiselect,
    SingleSelect
  },
  data() {
    return {
      payload: {
        tipoServico: "Serviço de Remoção",
        tipoServicoEspecialidade: [],
        tipoServicoAbrangencia: [],
        tipoServicoPublico: []
      },
      listaTiposRemocao: [],
      listaAbrangencias: []
    };
  },
  beforeMount() {
    this.inicializarEspecialidades();
    this.inicializarAbrangencias();
  },
  methods: {
    inicializarEspecialidades() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaTiposRemocao = [...data];
        }
      });
    },
    atualizarAbrangencias(valor) {
      this.payload.tipoServicoAbrangencia = valor;
    },
    inicializarAbrangencias() {
      return this.getAbrangencia(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaAbrangencias = [...data];
        }
      });
    }
  },
  watch: {
    "payload.tipoServicoAbrangencia": "emitir",
    "payload.tipoServicoPublico": `emitir`,
    dadosServidor(novoValor) {
      if (novoValor.especialidades.length > 0) {
        novoValor.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (novoValor.servicos.length > 0) {
        novoValor.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            servico.tipoServicoPublico
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (novoValor.abrangencias.length > 0) {
        novoValor.abrangencias.forEach(abrangencia => {
          if (
            abrangencia.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "abrangencia",
              abrangencia.tipoServicoAbrangencia
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>
